/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BiasTestRequest } from './BiasTestRequest';
import {
    BiasTestRequestFromJSON,
    BiasTestRequestFromJSONTyped,
    BiasTestRequestToJSON,
    BiasTestRequestToJSONTyped,
} from './BiasTestRequest';

/**
 * 
 * @export
 * @interface AddBiasTestsRequest
 */
export interface AddBiasTestsRequest {
    /**
     * 
     * @type {Array<BiasTestRequest>}
     * @memberof AddBiasTestsRequest
     */
    biasTests: Array<BiasTestRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof AddBiasTestsRequest
     */
    useSleepSchedule?: boolean;
}

/**
 * Check if a given object implements the AddBiasTestsRequest interface.
 */
export function instanceOfAddBiasTestsRequest(value: object): value is AddBiasTestsRequest {
    if (!('biasTests' in value) || value['biasTests'] === undefined) return false;
    return true;
}

export function AddBiasTestsRequestFromJSON(json: any): AddBiasTestsRequest {
    return AddBiasTestsRequestFromJSONTyped(json, false);
}

export function AddBiasTestsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddBiasTestsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'biasTests': ((json['bias_tests'] as Array<any>).map(BiasTestRequestFromJSON)),
        'useSleepSchedule': json['use_sleep_schedule'] == null ? undefined : json['use_sleep_schedule'],
    };
}

export function AddBiasTestsRequestToJSON(json: any): AddBiasTestsRequest {
    return AddBiasTestsRequestToJSONTyped(json, false);
}

export function AddBiasTestsRequestToJSONTyped(value?: AddBiasTestsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bias_tests': ((value['biasTests'] as Array<any>).map(BiasTestRequestToJSON)),
        'use_sleep_schedule': value['useSleepSchedule'],
    };
}

